import ConfigApi from "../api/gen/core/ConfigApi";

const skript = document.createElement('script');
const skript2 = document.createElement('script');
const noskript   = document.createElement('noscript');

export const setGTM = async () => {

    let config = await ConfigApi.getGoogleAnalyticsConfiguration().then(res => {
        return res;
    });

    if (config) {
        if (config.googleAnalyticsId && !document.head.contains(skript) && !document.head.contains(skript2)) { // Legacy
            const gaSkript =
                '  window.dataLayer = window.dataLayer || [];' +
                '  function gtag(){dataLayer.push(arguments);}' +
                "  gtag('js', new Date());" +
                "  gtag('config', '" +
                config.googleAnalyticsId +
                "');";

            const skriptText = document.createTextNode(gaSkript);
            skript.src = `https://www.googletagmanager.com/gtag/js?id="${config.googleAnalyticsId}"`;
            skript2.appendChild(skriptText);
            document.head.appendChild(skript);
            document.head.appendChild(skript2);

        } else if (config.googleTagManagerId && !document.head.contains(skript) && !document.body.contains(noskript)) { // new GTM

            const gtmSkript = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0]," +
                "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=" +
                "'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);" +
                "})(window,document,'script','dataLayer','" + config.googleTagManagerId + "');"

            const skriptText = document.createTextNode(gtmSkript);
            skript.appendChild(skriptText);
            const iframe = document.createElement("iframe");
            iframe.src = 'https://www.googletagmanager.com/ns.html?id=' + config.googleTagManagerId;
            noskript.appendChild(iframe)

            document.head.appendChild(skript);
            document.body.appendChild(noskript)

        }
    }
};
